<template>
  <div>
    <el-input placeholder="" readonly :value="displayValue" :clearable="true" @change="handleChange">
      <template slot="append"><el-button type="primary" @click="open">选择</el-button></template>
    </el-input>

    <mw-dialog size="small_large" title="选择节点" :footerButton="footerButton" ref="dialog">
      <div style="height: 100%;overflow: auto;">
        <el-table
          ref="list"
          :data="list"
          style="width: 100%;height:100%;"
          highlight-current-row
          :current-row-key="this.value && this.value.id"
          row-key = "id"
          height="100%"
          @current-change="handleSelectionChange">
          <el-table-column
            type="index"
            width="50">
          </el-table-column>
          <el-table-column
            align="center"
            label="名称">
            <template slot-scope="scope">{{ scope.row.name }}</template>
          </el-table-column>

          <el-table-column prop="department" label="办理部门"/>
          <el-table-column prop="sender" label="发送人"/>
          <el-table-column prop="assigneeName" label="办理人"/>
          <el-table-column prop="createTime" label="发送时间"/>
          <el-table-column prop="claimTime" label="签收时间"/>
        </el-table>
      </div>
    </mw-dialog>
  </div>
</template>

<script>
import api from "@/common/api/maintain";
export default {
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    batchId: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      footerButton: [
        {
          label: "确定",
          func: () => {
            this.mwRef("dialog").hide();
          }
        }
      ],
      list: [],
    };
  },

  computed: {
    displayValue() {
      if (this.value) {
        if (this.value.name !== undefined) {
          return this.value.name
        }
      }
      return '';
    }
  },

  methods: {
    async load() {
      this.list = (await api.getFlowProcess(this.batchId, {})).result;

      if (this.value && this.value.id) {
        for (let item of this.list) {
          if (item.id === this.value.id) {
            this.mwRef('list').setCurrentRow(item);
          }
        }
      }
    },
    open() {
      this.mwRef("dialog").show();
      this.load();
    },
    handleSelectionChange(x) {
      this.$emit("input", x);
    },
    handleChange(val) {
      if (!val) {
        this.$emit('input', {});
      }
    }
  }
};
</script>

<style>
</style>




// WEBPACK FOOTER //
// src/modules/index/views/systemSet/set/flowInterfering/common/processSelect.vue